<script setup lang="ts">
defineProps<{ crumbs: { label: string; path: string }[] }>()
</script>

<template>
  <nav class="crumb" aria-label="Fil d'ariane">
    <div class="container crumb__in">
      <template v-for="(c, i) in crumbs" :key="c.path">
        <router-link v-if="i < crumbs.length - 1" :to="c.path" class="crumb__link">{{ c.label }}</router-link>
        <span v-else class="crumb__current" aria-current="page">{{ c.label }}</span>
        <span v-if="i < crumbs.length - 1" class="crumb__sep" aria-hidden="true">›</span>
      </template>
    </div>
  </nav>
</template>

<style scoped>
.crumb {
  background: var(--bg-alt);
  border-bottom: 1px solid var(--border);
  font-size: 0.82rem;
}
.crumb__in {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  padding-top: 11px;
  padding-bottom: 11px;
}
.crumb__link {
  color: var(--muted);
}
.crumb__current {
  color: var(--title);
  font-weight: 600;
}
.crumb__sep {
  color: var(--green);
}
</style>
